<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<el-radio v-bind="$attrs" class="qw-radio-root"><slot></slot></el-radio>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwRadio",
	extends: BaseComponent,
	inheritAttrs: false,

}
</script>

<style lang="scss">

.qw-radio-root{
	&.hide-radio{
		.el-radio__input{
			opacity: 0;
		}

	}
	&.disabled-keep-text-color{
		.el-radio__input.is-disabled+span.el-radio__label{
			color: inherit;
			cursor: default;
		}
	}
	&.disabled-hide-radio{
		.el-radio__input.is-disabled{
			opacity: 0;
		}
	}
	&.el-radio{
		margin-right: 0;
		line-height: inherit;
		.el-radio__label{
			color: inherit;
		}
	}
}
</style>
